/** PLP page product title ADA fix  */

(function () {
  function convertTitlesToH3() {
    // Select all Boost product title DIVs that haven't been converted yet
    const titleDivs = document.querySelectorAll('div.boost-sd__product-title');

    titleDivs.forEach((oldDiv) => {
      // Create the replacement <h3> element
      const h3 = document.createElement('h3');

      // Copy all existing attributes (classes, IDs, data attributes) to the <h3>
      Array.from(oldDiv.attributes).forEach((attr) => {
        h3.setAttribute(attr.name, attr.value);
      });

      // Transfer the inner text/content
      h3.innerHTML = oldDiv.innerHTML;

      // Replace the <div> with the new <h3> in the DOM
      oldDiv.parentNode.replaceChild(h3, oldDiv);
    });
  }

  // Run on initial DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertTitlesToH3);
  } else {
    convertTitlesToH3();
  }

  // Observe DOM changes (Boost updates grid dynamically on filter/sort/pagination)
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldUpdate = true;
        break;
      }
    }
    if (shouldUpdate) {
      convertTitlesToH3();
    }
  });

  // Watch the page body for dynamic updates
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();



/* ADA Fix: perweb-AMP44
*/

// ADA FIX: Cart Subtotal Live Region Announcer
// Creates an empty aria-live region and watches the cart subtotal for changes
document.addEventListener('DOMContentLoaded', function() {
  // 1. Create the dedicated ARIA live region (must be empty on load)
  const liveRegion = document.createElement('div');
  liveRegion.classList.add('ada-sr-only');
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');
  liveRegion.setAttribute('role', 'status');
  document.body.appendChild(liveRegion);

  let previousSubtotal = null;

  // 2. Set up a MutationObserver to watch for DOM changes securely
  const observer = new MutationObserver(function(mutations) {
    // Target the specific subtotal element generated by the app
    const subtotalElement = document.querySelector('.docapp-cart-subtotal .money');

    if (subtotalElement) {
      const currentSubtotal = subtotalElement.textContent.trim();

      // Initialize previousSubtotal on first find without announcing
      if (previousSubtotal === null) {
        previousSubtotal = currentSubtotal;
        return;
      }

      // If the subtotal has changed, update the live region to announce it
      if (currentSubtotal !== previousSubtotal) {
        liveRegion.textContent = `Subtotal updated to ${currentSubtotal}`;
        previousSubtotal = currentSubtotal;

        // Clear the text after a short delay so consecutive identical updates are read cleanly
        setTimeout(() => {
          liveRegion.textContent = '';
        }, 3000);
      }
    }
  });

  // 3. Start observing the document for dynamically injected cart updates
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});


/**
 * ADA FIX: perweb–AMP25 – Ensure custom controls provide proper textual name, role, and state information
 */


document.addEventListener("DOMContentLoaded", () => {
  const fixBoostAdaLinks = () => {
    // Target Boost swatch buttons that haven't been fixed yet
    const buttons = document.querySelectorAll('button.boost-sd__product-swatch-more:not(.ada-fixed)');

    buttons.forEach(button => {
      // 1. Find the parent product card container
      const productCard = button.closest('.boost-sd__product-item, .grid-product');
      if (!productCard) return;

      // 2. Extract the product title and URL from the main product link
      const titleLink = productCard.querySelector('a.boost-sd__product-title, a.grid-product__title, a[href*="/products/"]');
      
      // Fallbacks in case the DOM structure varies slightly
      const productTitle = titleLink ? titleLink.textContent.trim() : 'this product';
      const productUrl = titleLink ? titleLink.getAttribute('href') : '#';

      // 3. Create the new, accessible native <a> element
      const anchor = document.createElement('a');
      anchor.href = productUrl;
      
      // Preserve all Boost classes for styling, plus a flag to prevent infinite loops
      anchor.className = button.className + ' ada-fixed';
      
      // 4. Set the contextual aria-label (e.g., "Show more options for Ribbed Crew Neck Tee")
      anchor.setAttribute('aria-label', `Show more options for ${productTitle}`);
      
      // Preserve the "+" inner HTML
      anchor.innerHTML = button.innerHTML;

      // 5. Replace the inaccessible button with the new anchor
      button.replaceWith(anchor);
    });
  };

  // Run immediately on page load for any server-rendered products
  fixBoostAdaLinks();

  // 6. Set up a MutationObserver to handle Boost's AJAX filtering/pagination
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldRun = true;
        break;
      }
    }
    // Re-run the fix if new products were injected into the DOM
    if (shouldRun) {
      fixBoostAdaLinks();
    }
  });

  // Attach the observer to the body to watch for Boost's DOM updates
  const targetNode = document.querySelector('body');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
});





/**
 * ADA Fix: perweb–AMP23 – Ensure custom controls provide proper textual name, role, and state information
 */


document.addEventListener('DOMContentLoaded', function() {
    // Wait to ensure jQuery is loaded (Slick Carousel requires it)
    var checkJquery = setInterval(function() {
      if (typeof window.jQuery !== 'undefined') {
        clearInterval(checkJquery);
        initSlickAccessibilityFix();
      }
    }, 100);

    function initSlickAccessibilityFix() {
      var $ = window.jQuery;

      // Core function to update the ARIA attributes
      function updateSlickAccessibility(slider) {
        var $slider = $(slider);
        
        $slider.find('.slick-dots li button').each(function() {
          var $btn = $(this);
          
          // Extract the number from the button text (e.g., "1")
          var slideNum = $btn.text().replace(/\D/g, ''); 
          
          // Satisfy the "Go to slide X" requirement if missing
          if (slideNum) {
             $btn.attr('aria-label', 'Go to slide ' + slideNum);
          }
          
          // Remove aria-current from all buttons to prevent duplicates
          $btn.removeAttr('aria-current');
        });

        // Find the active slide dot and apply aria-current="true"
        $slider.find('.slick-dots li.slick-active button').attr('aria-current', 'true');
      }

      // Delegate event listeners for dynamically injected sliders
      $(document).on('init afterChange', '.slick-slider, .boost-sd__slider-container', function(event) {
        updateSlickAccessibility(event.target);
      });

      // Fallback: Fire once to catch sliders that initialized before the script ran
      setTimeout(function() {
        $('.slick-slider, .boost-sd__slider-container, .slick-initialized').each(function() {
          updateSlickAccessibility(this);
        });
      }, 1500); 
    }
  });




/**
 * ADA Fix: Programmatically group visually related swatches
 * Targets elements with boost-sd classes to wrap them in a fieldset/legend
 */

document.addEventListener('DOMContentLoaded', function() {
  // Use a MutationObserver to catch elements if they are lazy-loaded by Boost
  const observer = new MutationObserver((mutations) => {
    const swatches = document.querySelectorAll('.boost-sd__radio-label:not(.ada-fixed)');
    
    if (swatches.length > 0) {
      // Find the parent container that needs grouping
      const container = swatches[0].closest('.boost-sd__unit-container'); // Adjust selector based on actual wrapper
      
      if (container && !container.querySelector('fieldset')) {
        const fieldset = document.createElement('fieldset');
        fieldset.setAttribute('role', 'radiogroup');
        fieldset.style.border = 'none';
        fieldset.style.padding = '0';
        
        const legend = document.createElement('legend');
        //legend.innerText = 'Color'; // Or pull dynamically from the visual label
        legend.className = 'visually-hidden'; // Keep it hidden if the visual text exists
        
        // Wrap the swatches
        container.parentNode.insertBefore(fieldset, container);
        fieldset.appendChild(legend);
        fieldset.appendChild(container);
        
        // Mark as fixed to avoid infinite loops
        swatches.forEach(s => s.classList.add('ada-fixed'));
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});



/**
 * Global Fix for Keyboard Accessibility on Product Zoom
 * Handles cases where buttons are dynamically generated.
 */

document.addEventListener('keydown', function(e) {
  // Target the button based on the classes seen in your inspector
  const zoomButton = e.target.closest('.js-photoswipe__zoom');
  
  if (!zoomButton) return;

  // Check for Enter (13) or Space (32)
  if (e.keyCode === 13 || e.keyCode === 32) {
    e.preventDefault();
    
    // 1. Manually trigger the click event that PhotoSwipe listens for
    zoomButton.click();
    
    // 2. Accessibility: Update ARIA state if needed
    const isExpanded = zoomButton.getAttribute('aria-expanded') === 'true';
    zoomButton.setAttribute('aria-expanded', !isExpanded);
  }
});

// Force ARIA labels on these buttons if they are missing
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver((mutations) => {
    const zoomButtons = document.querySelectorAll('.js-photoswipe__zoom:not([aria-label])');
    zoomButtons.forEach(btn => {
      btn.setAttribute('aria-label', 'Open image zoom');
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});



/**
 * ADA 118 aria-label on the image zoom feature on the media.liquid file.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Select the product slides or image wrappers
  const productImageContainers = document.querySelectorAll('.product-main-slide, .image-wrap');

  productImageContainers.forEach(function(container) {
    // Listen for keyboard events on the container
    container.addEventListener('keydown', function(event) {
      // Check if the key pressed is Enter (13) or Space (32)
      if (event.key === 'Enter' || event.key === ' ') {
        // Prevent default browser behavior (like scrolling down on Space)
        event.preventDefault(); 
        
        // Find the zoom button within this specific slide and trigger a click
        const zoomButton = this.querySelector('.js-photoswipe__zoom');
        if (zoomButton) {
          zoomButton.click();
        }
      }
    });
  });
});



/**
 * Reorders Yotpo Custom Questions DOM for Screen Readers
 * Matches Titles and Values based on their CSS Grid inline styles
 */

(function() {

    function fixYotpoReadingOrder() {
      // Find all custom question titles that haven't been processed yet
      const titles = document.querySelectorAll('.yotpo-custom-questions-title:not([data-a11y-processed])');
      
      if (titles.length === 0) return;

      // Find unique parent containers for these titles
      const containers = new Set();
      titles.forEach(title => containers.add(title.parentElement));

      containers.forEach(container => {
        // Get all titles in this specific container
        const containerTitles = Array.from(container.querySelectorAll('.yotpo-custom-questions-title:not([data-a11y-processed])'));
        
        containerTitles.forEach(title => {
          // Identify the exact row this title belongs to visually
          const rowStart = title.style.gridRowStart;
          
          if (!rowStart) return;

          // Find the corresponding value element in the same container.
          // It's the sibling element that is NOT a title, but shares the same grid-row-start.
          const valueElement = Array.from(container.children).find(sib => 
            !sib.classList.contains('yotpo-custom-questions-title') && 
            sib.style.gridRowStart === rowStart
          );

          if (valueElement) {
            // Reorder in the DOM: Append title first, then its value immediately after.
            // Because they use explicit grid-row-start styles, this will NOT break the visual layout.
            container.appendChild(title);
            container.appendChild(valueElement);
            
            // Mark as processed to prevent infinite loops with MutationObserver
            title.setAttribute('data-a11y-processed', 'true');
            valueElement.setAttribute('data-a11y-processed', 'true');
          }
        });
      });
    }

    // Set up a MutationObserver to watch for Yotpo's async loading and pagination changes
    function initYotpoObserver() {
      const observer = new MutationObserver((mutations) => {
        let shouldRun = false;
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length > 0) {
            shouldRun = true;
          }
        });

        if (shouldRun) {
          // Give Yotpo's internal scripts a brief moment to finish painting the DOM
          requestAnimationFrame(() => {
            fixYotpoReadingOrder();
          });
        }
      });

      // Start observing the body for injected Yotpo nodes
      observer.observe(document.body, { childList: true, subtree: true });
      
      // Run once immediately in case elements are already present
      fixYotpoReadingOrder();
    }

    // Initialize script on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initYotpoObserver);
    } else {
      initYotpoObserver();
    }
  })();



/**
 * ADA AMP107 Fix for Yotpo Smart Topics "Show More" Button
 * Fixes: Incorrect role, missing state, missing keyboard access, and focus management.
 */

function fixYotpoAccessibility() {
  const toggleBtn = document.querySelector('.yotpo-smart-topics-see-more-label');
  
  // Exit if the button isn't there or if we've already fixed it
  if (!toggleBtn || toggleBtn.hasAttribute('data-ada-fixed')) return;

  // 1. Correct the Role and Attributes
  toggleBtn.setAttribute('data-ada-fixed', 'true'); // Mark as fixed
  toggleBtn.setAttribute('role', 'button');
  toggleBtn.setAttribute('aria-expanded', 'false');
  toggleBtn.removeAttribute('aria-pressed'); // Remove incorrect toggle state
  
  // Enforce a static name as recommended by the audit
  toggleBtn.textContent = 'Additional Popular Topics'; 

  // 2. Keyboard Support (Enter and Space)
  toggleBtn.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleBtn.click(); // Trigger native app click
    }
  });

  // 3. State Management & Focus Routing on Click
  toggleBtn.addEventListener('click', function() {
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', !isExpanded);

    // Use a slight timeout to let Yotpo's internal script run and reveal the items
    setTimeout(() => {
      // Force text back in case Yotpo attempts to change it to "Show less"
      toggleBtn.textContent = 'Additional Popular Topics';

      if (!isExpanded) {
        // Move focus to the first newly revealed topic.
        // Yotpo generally shows 5-10 initially. We target the hidden ones that just appeared.
        // NOTE: You may need to adjust the nth-child index based on your specific Yotpo settings.
        const newlyRevealedTopic = document.querySelector('.yotpo-smart-topic-filter:nth-child(6)'); 
        
        if (newlyRevealedTopic) {
          // Make it programmatically focusable and move focus
          newlyRevealedTopic.setAttribute('tabindex', '-1');
          newlyRevealedTopic.focus();
        }
      }
    }, 150);
  });
}

// 4. MutationObserver to watch for Yotpo's asynchronous loading
const yotpoObserver = new MutationObserver((mutations) => {
  if (document.querySelector('.yotpo-smart-topics-see-more-label')) {
    fixYotpoAccessibility();
  }
});

// Start observing the document body
yotpoObserver.observe(document.body, { childList: true, subtree: true });


/* ADA Fix AMP106 Close Modal with Esc and keep correct tabindex order */


// 1. Create a variable to hold the trigger element globally
window.lastModalTrigger = null;

// 2. Listen for the click on the "Learn more" button
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('#shopify-installments-cta');
  
  if (trigger) {
    // Store the button so we can find it later
    window.lastModalTrigger = trigger;
  }
});

// 3. Listen for the "Close" action
// Shopify's installments modal usually triggers a 'close' event or removes a specific class
document.addEventListener('click', function (event) {
  // Check if the clicked element is a close button or the overlay backdrop
  if (event.target.matches('.shopify-installments-modal__close') || 
      event.target.matches('.shopify-installments-modal-backdrop')) {
    
    if (window.lastModalTrigger) {
      // Return focus to the "Learn more" link
      window.lastModalTrigger.focus();
    }
  }
});


document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' && window.lastModalTrigger) {
    // Small delay to ensure the modal has finished its closing animation
    setTimeout(() => {
      window.lastModalTrigger.focus();
    }, 100);
  }
});